export const generateLinkTarget = (openInNewTab?: boolean) => (openInNewTab ? "_blank" : undefined);

/**
 * Prefixes a CMS-managed relative href (e.g. `/terms`) with the current locale
 * (e.g. `/en/terms`) so links resolve directly instead of relying on the
 * middleware locale redirect. External URLs, anchors and already-localized
 * paths are returned unchanged.
 */
export function withLocalePrefix(href: string, locale: string, locales: readonly string[]): string {
  if (!href.startsWith("/") || href.startsWith("//")) {
    return href;
  }
  const firstSegment = href.split("/")[1] ?? "";
  if ((locales as readonly string[]).includes(firstSegment)) {
    return href;
  }
  return `/${locale}${href}`;
}
